import { Organization, Site } from 'interfaces';
import { useEffect } from 'react';
import { useCurrentSiteStore } from 'store/SiteStore';
import { useCurrentUserStore } from 'store/UserStore';

interface UseInitializeSiteProps {
  sites: Site[];
  organizations: Organization[];
  fetchedOrganizations: boolean;
  fetchedSites: boolean;
  selectedOrganizationID: string;
  setSelectedSiteID: React.Dispatch<React.SetStateAction<string>>;
  setSelectedOrganizationID: React.Dispatch<React.SetStateAction<string>>;
}

export const useInitializeSite = ({
  sites,
  organizations,
  fetchedSites,
  fetchedOrganizations,
  selectedOrganizationID,
  setSelectedSiteID,
  setSelectedOrganizationID,
}: UseInitializeSiteProps) => {
  useEffect(() => {
    const storedSite = JSON.parse(
      localStorage.getItem('site-storage') || 'null'
    );
    // Prefer an explicitly stored site (persisted) over a default
    if (storedSite?.state?.id) {
      const persisted = storedSite.state;
      const siteMatch = sites.find((s) => s.id === persisted.id) || persisted;
      useCurrentSiteStore.setState({ ...siteMatch });
      setSelectedSiteID(siteMatch.id);
      setSelectedOrganizationID(siteMatch.organizationID);
    } else if (storedSite?.state?.defaultSiteID) {
      const defaultSite = storedSite.state.defaultSiteID;
      const site = sites.find((s) => s.id === defaultSite);
      if (site) {
        useCurrentSiteStore.setState({ ...site });
        setSelectedSiteID(site.id);
        setSelectedOrganizationID(site.organizationID);
      }
    } else if (fetchedSites && sites.length > 0) {
      const firstSite = sites[0];
      useCurrentSiteStore.setState({ ...firstSite });
      setSelectedSiteID(firstSite?.id);
      setSelectedOrganizationID(firstSite?.organizationID);
    }
  }, [fetchedSites, sites]);

  useEffect(() => {
    if (setSelectedOrganizationID && fetchedOrganizations) {
      const currentUserStore = useCurrentUserStore.getState();
      if (currentUserStore.organizationID !== selectedOrganizationID) {
        const selectedOrg = organizations.find(
          (org) => org.id === selectedOrganizationID
        );
        useCurrentUserStore.setState({
          ...currentUserStore,
          organizationID: selectedOrganizationID,
          organization: selectedOrg,
        });
      }
    }
  }, [selectedOrganizationID, fetchedOrganizations]);
};
